import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  headerMain: {
    position: 'relative',
    minHeight: 56,
    paddingRight: 0,
    paddingLeft: 0,
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.up('sm')]: {
      minHeight: 70,
    },
    '& .langBtn': {
      borderLeft: '0 none',
      '&:hover, &:focus': {
        backgroundColor: 'transparent',
      },
    },
    '& .notiBtn': {
      color: theme.palette.grey[800],
      borderLeft: '0 none',
      '&:hover, &:focus': {
        color: theme.palette.text.primary,
        backgroundColor: 'transparent',
      },
      [theme.breakpoints.up('md')]: {
        color: theme.palette.grey[400],
        '&:hover, &:focus': {
          color: theme.palette.text.primary,
        },
      },
    },
  },
  appBarStyle:{
    zIndex: 99, position: 'sticky', top: 0,
    background:'#fff',
    borderBottom:'2px solid #D4D4D4',
    boxShadow:'none',

  },
  headerMainFlex: {
    display: 'flex',
    alignItems: 'center',
  },
  gudLogo:{
    width:'7%',
    maxWidth:'7%'
  },

  headerContainer: {
    width: '100%',
    marginLeft: 0,
    marginRight: 'auto',
    paddingLeft: 20,
    paddingRight: 20,
    [theme.breakpoints.up('lg')]: {
      // maxWidth: 1140,
      maxWidth: '100%',
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: '100%',
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  grow: {
    flexGrow: 1,
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      marginLeft: 'auto',
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  headerNav: {
    [theme.breakpoints.down('md')]: {
      width:'75%',
      maxWidth:'75%',
    },
    [theme.breakpoints.up('md')]: {
width:'77%',
maxWidth:'77%',
    },
    overflowY:'hidden',
    overflowX:'auto',
    scrollbarWidth:'none',
    height:'45px',
    maxHeight:'45px',
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: '#2e4167',
    color: theme.palette.primary.contrastText,
    '& .navbarNav': {
      display: 'flex',
      padding: 0,
      marginLeft: -16,
      marginRight: -16,
      [theme.breakpoints.up('lg')]: {
        marginLeft: -20,
        marginRight: -20,
      },
    },
    '& .navItem': {
      width: 'auto',
      cursor: 'pointer',
      height:'47px',
      [theme.breakpoints.up('lg')]: {
        paddingLeft: 20,
        paddingRight: 20,
      },
      '& .messageId':{
        fontSize:'13px',
        '& .MuiTypography-root':{
          fontSize:'13px'
        }
      },
      //inactive headers
      color: '#c5c0c0',
      '& .navLinkIcon': {
        color: '#c5c0c0',

        [theme.breakpoints.down('md')]: {
          display: 'none',
        },
        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
        // color: theme.palette.secondary.main,
      },
      // active headers
      '&.active': {
        color: '#fff',
        '& .messageId':{
          fontSize:'13px',
          '& .MuiTypography-root':{
            fontSize:'13px'
          }
        },
        '& .navLinkIcon': {
          color: '#fff',
          fontSize: 17,

          [theme.breakpoints.down('md')]: {
            display: 'none',
          },
          [theme.breakpoints.down('sm')]: {
            display: 'none',
          },
          // color: theme.palette.secondary.main,
        },
      },
    },
    '& .navLinkIcon': {
      marginRight: 10,
      color: theme.palette.primary.contrastText,
      fontSize: 17,

      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  },
  menuItemRoot: {
    padding: 0,
  },
  pointer: {
    cursor: 'pointer',
  },
  menuIconRoot: {
    width: '2.5rem',
    height: '2.5rem',
  },
  logoRoot: {
    height: 30,
  },
}));
export default useStyles;
